/* global translations */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MembersGridContainer, SearchSideContainer, SearchTopContainer } from './containers';
import SearchParamsStore from './stores/SearchParamsStore';
import MembersActionCreators from './actions/MembersActionCreators';
import MemberStore from './stores/MemberStore';

class SearchApp extends Component {
  state = {
    paginationUrl: this.props.paginationUrl,
    extended: this.props.extended,
  };

  constructor(props) {
    super(props);

    MemberStore.setLoading(true);
  }

  handleFormSubmission = (query) => {
    clearTimeout(this.formSubmissionTimeout);

    // Ja jau tiek lādēti lietotāji,
    // tad neveic jaunu pieprasījumu, kamēr nav pabeigts iesāktais.
    // Ja maina vairākas lietas, kamēr tiek veikts iepriekšējais pieprasījums,
    // tad katrai izmaiņai nebūs jauns pieprasījums.
    // Būs viens, kur tiks iekļautas visas izmaiņas, kas veiktas,
    // kamēr iesāktais pieprasījums tiek pabeigts.
    // Laiku, pēc kura tiek pārbaudīts, vai iepriekšējais pieprasījums ir pabeigts,
    // var arī pamainīt. Šobrīd tas ir 0.1s un izskatās, ka ir ok.
    if (MemberStore.getLoading()) {
      // Nelādē arī nākamo lapu iepriekšējiem kritērijiem, lai ātrāk ielādētos ar jaunajiem
      MemberStore.setLoadNextPage(false);
      this.formSubmissionTimeout = setTimeout(() => { this.handleFormSubmission(query); }, 100);
      return;
    }

    MemberStore.setLoadNextPage(true);
    this.submitForm(query);
  };

  submitForm = (query) => {
    const searchQuery = (typeof query === 'undefined') ? SearchParamsStore.getQuery() : query;

    MemberStore.setLoading(true);
    MemberStore.setFetchedMembersPage(1);
    MemberStore.setBiggestActivePage(1, 'search');
    MemberStore.removeFetchedMemberIdsPage('all');
    MembersActionCreators.loadFetchedMembers(1, null, `${this.props.paginationUrl}?${searchQuery}`);

    this.setState({
      paginationUrl: `${this.props.paginationUrl}?${searchQuery}`,
    });
  };

  handleExtendedChange = (extended) => {
    this.setState({
      extended,
    });
  };

  handleResetCache = () => {
    const searchQuery = `${SearchParamsStore.getQuery()}&reset=1`;
    this.submitForm(searchQuery);
  };

  render() {
    const {
      showName,
      type,
      membersId,
      pagination,
      itemsCountPerPage,
      slider,
      slideTotal,
      totalItemsCount,
      headerTitle,
      headerShowAll,
      customImages,
      page,
      menuType,
    } = this.props;

    const {
      extended,
      paginationUrl,
    } = this.state;

    return (
      <div>
        <div className="content-left block pam">
          <div className="btn btn--c btn--block btn--iconLeft searchFiltersBtn">
            <span>{translations['txt: Filtri']}</span>
            <span className="btn-static">
              <span className="vcenter">
                <span className="vcenter-inner">
                  <div className="filters-svg">
                    <svg viewBox="-100 -100 1200 1200" className="icon">
                      <path d="M561.8,232.3c-60,0-108.6-48.6-108.6-108.7S501.8,15,561.8,15s108.7,48.6,108.7,108.7S621.8,232.3,561.8,232.3z M232.3,527.3c0-60-48.6-108.6-108.7-108.6S15,467.3,15,527.3S63.6,636,123.7,636S232.3,587.3,232.3,527.3z M453.1,123.7H15 M670.4,123.7H757 M232.3,527.3H757" />
                    </svg>
                  </div>
                </span>
              </span>
            </span>
          </div>
          <SearchSideContainer
            showName={showName}
            submitForm={this.handleFormSubmission}
            type={type}
          />
        </div>
        <div className="content-main">
          <SearchTopContainer
            changeExtended={this.handleExtendedChange}
            extended={extended}
            resetCache={this.handleResetCache}
          />
          <MembersGridContainer
            membersId={membersId}
            extended={extended}
            pagination={pagination}
            itemsCountPerPage={itemsCountPerPage}
            slider={slider}
            slideTotal={slideTotal}
            totalItemsCount={totalItemsCount}
            headerTitle={headerTitle}
            headerShowAll={headerShowAll}
            type={type}
            section="search"
            customImages={customImages}
            paginationUrl={paginationUrl}
            page={page}
            checkShowDistance
            checkErrors
            menuType={menuType}
          />
        </div>
      </div>
    );
  }
}

SearchApp.propTypes = {
  page: PropTypes.number,
  extended: PropTypes.bool,
  type: PropTypes.string,
  totalItemsCount: PropTypes.number,
  customImages: PropTypes.string,
  headerShowAll: PropTypes.string,
  headerTitle: PropTypes.string,
  slideTotal: PropTypes.number,
  slider: PropTypes.bool,
  pagination: PropTypes.bool,
  itemsCountPerPage: PropTypes.number,
  paginationUrl: PropTypes.string,
  membersId: PropTypes.arrayOf(PropTypes.string),
  showName: PropTypes.bool,
  menuType: PropTypes.string,
};

SearchApp.defaultProps = {
  itemsCountPerPage: 20,
  pagination: false,
  slider: false,
  slideTotal: 8,
  type: 'regular',
  customImages: null,
  paginationUrl: null,
  page: 1,
  totalItemsCount: 0,
  membersId: [],
  headerTitle: undefined,
  headerShowAll: '',
  extended: false,
  showName: false,
  menuType: 'user',
};

export default SearchApp;
